import React from 'react';
import Inputs from 'components/inputs/inputs';
import './siteNode.css';
import Helpers from 'utils/helpers';

class SiteNode extends React.Component {
  constructor(props) {
    super(props);
    const { node, siteByNodeIdMap, hidden, selectable } = props;

    this.state = {
      isExpanded: siteByNodeIdMap[node.id].isExpanded,
      isSelected: siteByNodeIdMap[node.id].isSelected,
      childrenSelectedCount: siteByNodeIdMap[node.id].childCountSelected,
      childrenSelectableCount: siteByNodeIdMap[node.id].childCountSelectable,
      hidden,
      selectable,
    };
  }

  handleExpand(event, node, siteByNodeIdMap) {
    if (event?.preventDefault) {
      event.preventDefault();
    }
    siteByNodeIdMap[node.id].isExpanded = true;
    this.setState({ isExpanded: true });
  }

  handleCollapse(event, node, siteByNodeIdMap) {
    if (event?.preventDefault) {
      event.preventDefault();
    }
    siteByNodeIdMap[node.id].isExpanded = false;
    this.setState({ isExpanded: false });
  }

  onLabelClick(event, siteByNodeIdMap, node) {
    if (event?.preventDefault) {
      event.preventDefault();
    }
    this.handleChange(node.id, this.state.isSelected ? 0 : 1, siteByNodeIdMap);
  }

  handleSingleChange(id, newValue, siteByNodeIdMap) {
    this.props.onSingleChange(id, newValue, []);
  }

  handleChildSingleChange(childId, childNewValue, parentsChain, parentNode, node, siteByNodeIdMap) {
    parentsChain.push(parentNode);
    this.props.onSingleChange(childId, childNewValue, parentsChain);
  }

  handleRecursiveChange(id, newValue, siteByNodeIdMap) {
    this.props.onRecursiveChange(id, newValue, []);
    this.setState({ isSelected: siteByNodeIdMap[id].isSelected, childrenSelectedCount: siteByNodeIdMap[id].childCountSelected });
  }

  handleChildRecursiveChange(childId, childNewValue, parentsChain, parentNode, node, siteByNodeIdMap) {
    parentsChain.push(parentNode);
    this.props.onRecursiveChange(childId, childNewValue, parentsChain);
    if (siteByNodeIdMap[node.id].isSelected !== this.state.isSelected) {
      this.setState({ isSelected: siteByNodeIdMap[node.id] });
    }

    if (siteByNodeIdMap[node.id].childCountSelected !== this.state.childrenSelectedCount) {
      this.setState({ childrenSelectedCount: siteByNodeIdMap[node.id].childCountSelected });
    }
  }

  renderList(mainNode, siteByNodeIdMap) {
    const { id } = mainNode;
    if (!siteByNodeIdMap[id].isExpanded) return null;

    const directChildren = siteByNodeIdMap[id].children.sort((item1, item2) => {
      //sort children by putting stores on bottom and other types on top, then by hierarchy name
      if (item1.typeId > item2.typeId && item1.typeId === 5) {
        return 1;
      }
      if (item1.typeId < item2.typeId && item2.typeId === 5) {
        return -1;
      }
      return item1.name.localeCompare(item2.name, undefined, { sensitivity: 'base' });
    });

    const children = directChildren.map((node) => (
      <SiteNode
        key={node.id}
        node={node}
        level={(this.props.level || 1) + 1}
        filterString={this.props.filterString}
        useFiltering={this.props.useFiltering}
        siteByNodeIdMap={siteByNodeIdMap}
        hidden={siteByNodeIdMap[node.id].hidden}
        selectable={siteByNodeIdMap[node.id].selectable}
        isSingleSelect={this.props.isSingleSelect}
        variant={this.props.variant}
        isReadOnly={this.props.isReadOnly}
        onRecursiveChange={(childId, childNewValue, parentsChain) => {
          this.handleChildRecursiveChange(childId, childNewValue, parentsChain, mainNode, node, siteByNodeIdMap);
        }}
        onSingleChange={(childId, childNewValue, parentsChain) => {
          this.handleChildSingleChange(childId, childNewValue, parentsChain, mainNode, node, siteByNodeIdMap);
        }}
      />
    ));

    return <div className={`site-list level-${this.props.level}`}>{children}</div>;
  }

  renderExpandSection(node, siteByNodeIdMap) {
    if (node.typeId === 5) {
      return (
        <div className='site-node-expand'>
          <i className='icons8-online-shop site-node-expand-icon-3' />
        </div>
      );
    }
    else {
      if (siteByNodeIdMap[node.id].children.length === 0) {
        return (
          <div className='site-node-expand'>
            <i className='site-node-expand-icon' />
            <i className='icons8-office-2 site-node-expand-icon-2' />
          </div>
        );
      }
      else if (this.state.isExpanded) {
        return (
          <div className='site-node-expand active' onClick={(e) => this.handleCollapse(e, node, siteByNodeIdMap)}>
            <i className='icons8-sort-down-2 site-node-expand-icon' />
            <i className='icons8-sort-down site-node-expand-icon-hover' />
            <i className='icons8-office site-node-expand-icon-2' />
          </div>
        );
      }
      else {
        return (
          <div className='site-node-expand active' onClick={(e) => this.handleExpand(e, node, siteByNodeIdMap)}>
            <i className='icons8-sort-right-2 site-node-expand-icon' />
            <i className='icons8-sort-right site-node-expand-icon-hover' />
            <i className='icons8-office site-node-expand-icon-2' />
          </div>
        );
      }
    }
  }

  renderMultiSelectSection(node, siteByNodeIdMap) {
    if (this.props.isSingleSelect) {
      return null;
    }
    if (this.props.isReadOnly) {
      return null;
    }
    if (this.state.childrenSelectableCount === 0) {
      return null;
    }

    const isAll = this.state.childrenSelectedCount === this.state.childrenSelectableCount;
    const isSome = this.state.childrenSelectedCount > 0;
    let text = `0 of ${this.state.childrenSelectableCount}`;
    if (isAll) {
      text = `ALL of ${this.state.childrenSelectableCount}`;
    }
    else if (isSome) {
      text = `${this.state.childrenSelectedCount} of ${this.state.childrenSelectableCount}`;
    }

    return (
      <span className='site-node-multi-badge'>
        <Inputs.Checkbox
          className='mr-0'
          variant={this.props.variant || 'success'}
          checked={isAll}
          indeterminate={!isAll && isSome}
          label={text}
          onValueChange={(v) => this.handleRecursiveChange(node.id, v, siteByNodeIdMap)}
        />
      </span>
    );
  }

  renderTitleSection(node, siteByNodeIdMap) {
    let title = <span>{node.name}</span>;
    if (this.props.useFiltering) {
      const parts = node.name.split(new RegExp(`(${this.props.filterString})`, 'gi'));
      title = (
        <span>
          {parts.map((part, i) =>
            <span className={part.toLowerCase() === this.props.filterString.toLowerCase() ? 'bg-highlighter' : ''} key={i}>
              {part}
            </span>
          )}
        </span>
      );
    }

    let indicator = null;
    if (this.props.isSingleSelect && this.state.childrenSelectedCount > 0) {
      indicator = <span className='site-node-title-indicator'></span>;
    }

    if (this.state.selectable) {
      return (
        <span
          className={Helpers.String.join(['site-node-title', 'active', (this.state.isSelected ? 'selected' : null)])}
          onClick={() => this.handleSingleChange(node.id, !this.state.isSelected, siteByNodeIdMap)}
        >
          <i className='icons8-checkmark site-node-title-icon' />
          {indicator}
          {title}
        </span>
      );
    }
    else {
      return (
        <span className='site-node-title'>
          {indicator}
          {title}
        </span>
      );
    }
  }

  componentDidUpdate(prevProps) {
    const { siteByNodeIdMap, node } = this.props;
    if (this.state.isExpanded !== siteByNodeIdMap[node.id].isExpanded) {
      this.setState({ isExpanded: siteByNodeIdMap[node.id].isExpanded });
    }
    if (this.state.isSelected !== siteByNodeIdMap[node.id].isSelected) {
      this.setState({ isSelected: siteByNodeIdMap[node.id].isSelected });
    }
    if (this.state.childrenSelectedCount !== siteByNodeIdMap[node.id].childCountSelected) {
      this.setState({ childrenSelectedCount: siteByNodeIdMap[node.id].childCountSelected });
    }
    if (this.state.childrenSelectableCount !== siteByNodeIdMap[node.id].childCountSelectable) {
      this.setState({ childrenSelectableCount: siteByNodeIdMap[node.id].childCountSelectable });
    }
    if (this.props.hidden !== prevProps.hidden) {
      this.setState({ hidden: this.props.hidden });
    }
    if (this.props.selectable !== prevProps.selectable) {
      this.setState({ selectable: this.props.selectable });
    }
  }

  componentDidMount() {
    this.props.siteByNodeIdMap[this.props.node.id].refreshSelected = (isSelected) => {
      this.setState({ isSelected });
    };
  }

  componentWillUnmount() {
    this.props.siteByNodeIdMap[this.props.node.id].refreshSelected = null;
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { siteByNodeIdMap, node } = this.props;
    if (this.state.isExpanded !== siteByNodeIdMap[node.id].isExpanded) {
      return true;
    }
    if (this.state.isSelected !== siteByNodeIdMap[node.id].isSelected) {
      return true;
    }
    if (this.state.childrenSelectedCount !== siteByNodeIdMap[node.id].childCountSelected) {
      return true;
    }
    if (this.state.childrenSelectableCount !== siteByNodeIdMap[node.id].childCountSelectable) {
      return true;
    }
    if (this.props.hidden !== nextProps.hidden) {
      return true;
    }
    if (this.props.selectable !== nextProps.selectable) {
      return true;
    }

    if (siteByNodeIdMap[node.id].children.children !== 0) {
      return true;
    }

    if (nextProps.filterString !== this.props.filterString) {
      return true;
    }

    return false;
  }

  render() {
    const { node, siteByNodeIdMap } = this.props;

    if (this.state.hidden) {
      return null;
    }

    return (
      <div className='site-node' node_id={node.id}>
        <div className='site-node-controls'>
          {this.renderExpandSection(node, siteByNodeIdMap)}
          {this.renderMultiSelectSection(node, siteByNodeIdMap)}
          {this.renderTitleSection(node, siteByNodeIdMap)}
        </div>

        {this.renderList(node, siteByNodeIdMap)}
      </div>
    );
  }
}

export default SiteNode;
